import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './bootstrap/axios';
import './index.css';
import { PostHogProvider } from 'posthog-js/react';

Sentry.init({
  dsn: 'https://e3807cdc330800abb6adfc05cfdffb57@o4509230734180353.ingest.us.sentry.io/4509230735228928',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events

  integrations: [Sentry.replayIntegration()],

  sendDefaultPii: true,
  // Replays
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0
});

const posthogApiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const posthogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com';

const posthogOptions = {
  api_host: posthogHost,
  loaded: () => {
    if (import.meta.env.DEV) {
      console.log('PostHog loaded successfully');
    }
  },
  capture_pageview: false,
  capture_pageleave: true,
  secure_cookie: true
};

const AppWithProviders = () => {
  if (!posthogApiKey) {
    console.warn('PostHog API key not found. Analytics will be disabled.');
    return <App />;
  }

  try {
    return (
      <PostHogProvider
        apiKey={posthogApiKey}
        options={posthogOptions}
      >
        <App />
      </PostHogProvider>
    );
  } catch (error) {
    console.warn('PostHog initialization failed:', error);
    return <App />;
  }
};

ReactDOM.createRoot(document.getElementById('root')!).render(<AppWithProviders />);
